/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import Blogs from '@/views/Blog/Blogs'
import AddBlog from '@/views/Blog/AddBlog'
import EditBlog from '@/views/Blog/EditBlog'
import YoutubeMusic from '@/views/Youtube/YoutubeMusic'
import AddYoutubeMusic from '@/views/Youtube/AddYoutubeMusic'
import EditYoutubeMusic from '@/views/Youtube/EditYoutubeMusic'
import Releases from '@/views/Release/Releases'
import AddRelease from '@/views/Release/AddRelease'
import EditRelease from '@/views/Release/EditRelease'
import Admins from '@/views/Admin/Admins'
import AddAdmin from '@/views/Admin/AddAdmin'
import EditAdmin from '@/views/Admin/EditAdmin'
import Users from '@/views/User/Users'
import HomepageBanners from '@/views/HomepageBanner/HomepageBanners'
import AddHomepageBanner from '@/views/HomepageBanner/AddHomepageBanner'
import EditHomepageBanner from '@/views/HomepageBanner/EditHomepageBanner'
import YoutubeBanners from '@/views/YoutubeBanner/YoutubeBanners'
import AddYoutubeBanner from '@/views/YoutubeBanner/AddYoutubeBanner'
import EditYoutubeBanner from '@/views/YoutubeBanner/EditYoutubeBanner'
import Queries from '@/views/Queries'
import ViewQuery from '@/views/ViewQuery'
import Newsletters from '@/views/Newsletters'
import Submissions from '@/views/Submission/Submissions'
import store from '../store.js'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login',
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        requiresAuth: true
      }
    },
    {
      path: '/blogs',
      name: 'Blogs',
      component: Blogs,
      meta: {
        title: 'Blogs',
        requiresAuth: true
      }
    },
    {
      path: '/add-blog',
      name: 'AddBlog',
      component: AddBlog,
      meta: {
        title: 'Add Blog',
        requiresAuth: true
      }
    },
    {
      path: '/edit-blog/:id',
      name: 'EditBlog',
      component: EditBlog,
      meta: {
        title: 'Edit Blog',
        requiresAuth: true
      }
    },
    {
      path: '/youtube-music',
      name: 'Music',
      component: YoutubeMusic,
      meta: {
        title: 'Youtube Music',
        requiresAuth: true
      }
    },
    {
      path: '/add-youtube-music',
      name: 'AddYoutubeMusic',
      component: AddYoutubeMusic,
      meta: {
        title: 'Add Youtube Music',
        requiresAuth: true
      }
    },
    {
      path: '/edit-youtube-music/:id',
      name: 'EditYoutubeMusic',
      component: EditYoutubeMusic,
      meta: {
        title: 'Edit Youtube Music',
        requiresAuth: true
      }
    },
    {
      path: '/releases',
      name: 'Releases',
      component: Releases,
      meta: {
        title: 'Releases',
        requiresAuth: true
      }
    },
    {
      path: '/add-release',
      name: 'AddRelease',
      component: AddRelease,
      meta: {
        title: 'Add Release',
        requiresAuth: true
      }
    },
    {
      path: '/edit-release/:id',
      name: 'EditRelease',
      component: EditRelease,
      meta: {
        title: 'Edit Release',
        requiresAuth: true
      }
    },
    {
      path: '/admins',
      name: 'Admins',
      component: Admins,
      meta: {
        title: 'Admins',
        requiresAuth: true
      }
    },
    {
      path: '/add-admin',
      name: 'AddAdmin',
      component: AddAdmin,
      meta: {
        title: 'Add Admin',
        requiresAuth: true
      }
    },
    {
      path: '/edit-admin/:id',
      name: 'EditAdmin',
      component: EditAdmin,
      meta: {
        title: 'Edit Admin',
        requiresAuth: true
      }
    },
    {
      path: '/homepage-banners',
      name: 'HomepageBanners',
      component: HomepageBanners,
      meta: {
        title: 'Homepage Banners',
        requiresAuth: true
      }
    },
    {
      path: '/add-homepage-banner',
      name: 'AddHomepageBanner',
      component: AddHomepageBanner,
      meta: {
        title: 'Add Homepage Banner',
        requiresAuth: true
      }
    },
    {
      path: '/edit-homepage-banner/:id',
      name: 'EditHomepageBanner',
      component: EditHomepageBanner,
      meta: {
        title: 'Edit Homepage Banner',
        requiresAuth: true
      }
    },
    {
      path: '/youtube-banners',
      name: 'YoutubeBanners',
      component: YoutubeBanners,
      meta: {
        title: 'Youtube Banners',
        requiresAuth: true
      }
    },
    {
      path: '/add-youtube-banner',
      name: 'AddYoutubeBanner',
      component: AddYoutubeBanner,
      meta: {
        title: 'Add Youtube Banner',
        requiresAuth: true
      }
    },
    {
      path: '/edit-youtube-banner/:id',
      name: 'EditYoutubeBanner',
      component: EditYoutubeBanner,
      meta: {
        title: 'Edit Youtube Banner',
        requiresAuth: true
      }
    },
    {
      path: '/queries',
      name: 'Queries',
      component: Queries,
      meta: {
        title: 'Contact Us Queries',
        requiresAuth: true
      }
    },
    {
      path: '/query/:id',
      name: 'ViewQuery',
      component: ViewQuery,
      meta: {
        title: 'View Contact Query',
        requiresAuth: true
      }
    },
    {
      path: '/newsletters',
      name: 'Newsletters',
      component: Newsletters,
      meta: {
        title: 'Newsletter Subscriptions',
        requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: {
        title: 'Users',
        requiresAuth: true
      }
    },
    {
      path: '/submissions',
      name: 'Submissions',
      component: Submissions,
      meta: {
        title: 'Submissions',
        requiresAuth: true
      }
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js